import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { SiteGate } from "@/components/SiteGate";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Account from "@/pages/Account";
import Subscriptions from "@/pages/Subscriptions";
import Admin from "@/pages/Admin";
import ResetPassword from "@/pages/ResetPassword";
import Voorwaarden from "@/pages/Voorwaarden";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <SiteGate>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/account" element={<Account />} />
                <Route path="/abonnementen" element={<Subscriptions />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/wachtwoord-reset" element={<ResetPassword />} />
                <Route path="/voorwaarden" element={<Voorwaarden />} />
              </Routes>
            </SiteGate>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
